import { BiTransfer } from "react-icons/bi";
import ssoImg1 from "./../../../../assets/images/tabimg-1.png"; // Adjust the path as necessary
import ssoImg2 from "./../../../../assets/images/tabimg-2.png"; // Adjust the path as necessary
import Doc1 from "./../../../../Documents/OffshoreBunkering/List of Agents for STS Bunkering.pdf";
import Doc2 from "./../../../../Documents/OffshoreBunkering/List of Bunker Operators - Algoa bay.pdf";
import Doc3 from "./../../../../Documents/OffshoreBunkering/List of Licenced operators  - Algoa Bay.pdf";

function OffshoreBunkering() {
  return (
    <>
<div className="service-title font-700 mb-3">Offshore <span className="text-orange-ef3e33 font-400 text-uppercase">Bunkering</span></div>

<div className="row g-3 g-sm-4 g-md-5">
   
    <div className="col-12">
          <p className="mb-4 font-18 font-900">
           ​​Application for OPL launch operation
          </p>
            <p className="mb-4 font-18 font-900">
           REQUIREMENTS:
          </p>
        

         <div className="accordion blackTab" id="blackTab">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabOne"
                  aria-expanded="false"
                  aria-controls="blackTabOne"
                >STS Offshore Bunker Application to Authority 
                </button>
              </h2>
              <div
                id="blackTabOne"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                    <p className="font-18 mb-4">
        A completed SAMSA approved application form is to be sent to the Authority for each STS bunker operation through the local​SAMSA Office. The form will include following information but not limited to:
         </p>

         <ul className="trust">
            <li>Details of the ship to receive Bunkers:
            <ul className="star-li">                    
                    <li>Name of vessel </li>
                    <li>Name of owners </li>
                    <li>Port of registry/Flag </li>
                    <li>IMO number </li>
                    <li>Classification society </li>
                    <li>Gross registered tons </li>
                    <li>Drafts </li>
                    <li>Ship Type </li>
                    <li>ETA/ Proposed date of operations</li>
            </ul></li>
            <li>Full contact details of local operator, owner or agent.
            </li>
            <li>
              Copies of the following documents:
              <ul className="star-li">                    
                    <li>P&I Certificate of Entry from a P&I club, that is a member of the International Group.</li>
                    <li>Certificate of insurance or other financial security in respect of Civil Liability for Bunker Oil Pollution Damage.</li>
                    <li>Certificate of insurance or other financial security in respect of Civil Liability for The Removal of Wrecks. </li>
                    <li>International Oil Pollution Prevention Certificate. </li>
                    <li>Port State Control Inspection Report.</li>
            </ul>
            </li>
            
        </ul>
          <p className="mb-4 font-18 font-900">
          The master shall ensure that:
          </p>
          <ul class="green-star-ul">
            <li>His vessel’s main engine is ready for immediate use during the proposed transfer.
            </li>
            <li>
                Any emergency resulting in a spill or threatening to cause a spill must be brought to the attention of the nearest SAMSA Principal Officer as soon as possible.
            </li>            
            </ul>
             <p className="mb-4 font-18 font-900">
          The Post Bunkering information report shall be communicated to SAMSA. This information is to include as a minimum, times when vessel:
          </p>
          <ul class="green-star-ul">
            <li>Anchored</li>
            <li>Bunker barge is all fast alongside</li>
            <li>Bunker hoses are connected</li>
            <li>Commenced bunker transfer</li>
            <li>Completed bunker transfer</li>
            <li>Bunker hoses were disconnected</li>
            <li>Bunker barge is away</li>
            <li>Anchor aweigh and vessel departing</li>
         </ul>
         </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button "
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabTwo"
                  aria-expanded="true"
                  aria-controls="blackTabTwo"
                >Approval for transfer of bunkers is subject to Authority’s right to the following. 
                </button>
              </h2>
              <div
                id="blackTabTwo"
                className="accordion-collapse collapse show"                
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <ul class="green-star-ul">
            
            <li>Permission may be refused for bunker transfer to take place.</li>
            <li>Change the proposed position of the transfer operation.</li>
            <li>A designated representative officer may board the vessel prior to and for the duration of the transfer.</li>
            <li>Conduct an inspection of the vessel to ensure compliance with the Act and the Prevention and Combating of marine Pollution by Oil regulations.</li>
           
         </ul>
                  </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabThree"
                  aria-expanded="false"
                  aria-controls="blackTabThree"
                >Offences and penalties
                </button>
              </h2>
              <div
                id="blackTabThree"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab">
                <div className="accordion-body">
                   <ul class="green-star-ul">
            
            <li>
                Any person(s) conducting a bunker transfer operation without the permission of the Authority is guilty of an offence for which the penalty as dictated by the Marine Pollution (Control and Civil Liability) Act No. 6 of 1981 is currently a maximum R90,000.00 (ninety thousand rand) or two years imprisonment or both.
            </li>  
            <li>It is an offence to discharge oil or any harmful substance into the sea area under the jurisdiction of the Republic of South Africa. The penalty for such discharge is dictated by the Marine Pollution (Prevention of Pollution from Ships) Act No.2 of 1986 and is currently a maximum of R500,000.00 (five hundred thousand rand) or five years imprisonment or both.
            </li>
            </ul>         
                </div>
               </div>
             </div>   
             <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTab4"
                  aria-expanded="false"
                  aria-controls="blackTab4"
                >International trading vessels
                </button>
              </h2>
              <div
                id="blackTab4"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab">
                <div className="accordion-body">
                  <p className="mb-3">
                    The current interim conditions/restrictions as of 01 September 2017 are stated in the following order:
                     </p>
                      <ul className="trust">
                         <li>All international trading vessels calling offshore Algoa bay anchorage are subject to a maximum draught restriction of 17 metres.
                        </li>
                        <li>Dry-bulk carries and Oil / or Chemical tankers are restricted to a maximum Gross Tonnage (GT) of 90 000; any other types of vessels are exempted from this restriction.
                        </li>
                        <li>Dry-bulk carries and Oil /or Chemical tankers of more than 90 000 GT will only be allowed to anchor / or bunker at Algoa bay if the following conditions are met:
                            <ul className="star-li">                    
                            <li>Owners shall, at their expense, have a standby tug (connected) at the station, of a suitable pollard pull and towing gear approved by SAMSA and TNPA.</li>
                            <li>Entry and exit from the anchorage is only permitted during daylight hours only i.e. between sunrise and sunset. </li>
                            <li>TNPA pilotage required.</li>
                            <li>All other vetting requirements and SOPs must be satisfied.</li>
                            
                         </ul></li></ul>
                           <ul className="trust">
                         <li>
                            Laden tankers of less than 90 000 GT are permitted to bunker or anchor at Agloa Bay, however, are subject to the following conditions:
                           <ul className="star-li">                    
                            <li>Entry and exit from the anchorage is only permitted during daylight hours only i.e. between sunrise and sunset.  </li>
                            <li>TNPA pilotage required.</li>
                            <li>Swell of max 1.5m and wind max 15knots</li>
                            <li>All other vetting conditions and SOPs must be satisfied.</li>                            
                         </ul></li>
                         <li>Vessels shall conduct an Oil Pollution Emergency​​ Drill within 7 days prior to bunkering ETA</li>
                         <li>No deballasting operations may be conducted without the permission of the authority while in Algoa bay</li>
                         <li>No crew changes, loading or discharging of spares, or victualing are allowed during a STS bunker transfer.</li>
                         <li>The provisions referred to in paragraphs 2, 3 and 4 do not apply to licensed local bunker tankers operating in the bay but must still comply with other general conditions / SOPs applicable to all vessels.</li>
                         <li>The Authority reserves the right to reject any STS bunkering operation if the applicable requirements are not satisfied.</li>
                         </ul>           
                </div>
               </div>
             </div>
             <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTab5"
                  aria-expanded="false"
                  aria-controls="blackTab5"
                >Vessels other than international trading vessels.
                </button>
              </h2>
              <div
                id="blackTab5"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab">
                <div className="accordion-body">
                 <ul className="trust">
                         <li>
                            Fishing Vessels
                            <ul className="star-li"> 
                            <li>Fishing vessels with a length less than the bunker tanker will be required to go alongside the bunker tanker, which will be at anchor.

                            </li>
                            <li>This operation will only be permitted during daylight hours and within the SOP limitations regarding weather.

                            </li>
                            <li>The docking and undocking of the fishing vessel shall be under pilotage;

                            </li>
                            <li>The Master of the bunker tanker shall ensure that all anti-pollution measures are in place on board the fishing vessel as per the checklist.
                            </li>
                            <li>Only dedicated bunker tanks may be loaded; bulk storage in bladders, drums and the fish hold, etc. is not permitted.
                            </li>
                            <li>The first, and if deemed necessary, subsequent operations shall be carried out under the supervision of SAMSA. And
                            </li>
                            <li>Only the bunkering of non-South African registered fishing vessels is permitted.
                            </li>
                            </ul>
                            </li>
                            <li>Offshore Supply Vessels and Anchor Handlers<ul className="star-li"> 
                            <li>Vessels with a length less than the bunker tanker will be required to go alongside the bunker tanker, which will be at anchor.</li>
                            
                            </ul>
                            </li>
                            <li>Drill Ships, FPSO and MODU<ul className="star-li"> 
                            <li>
                                Drill ships are considered “normal" vessels.
                                </li>
                                <li>
                                    FPSO and MODU are deemed to be special cases and each operation will be approved individually.
                                </li>
                            </ul>
                            </li>

                            <li>Tugs undertaking towing operations<ul className="star-li"> 
                            <li>The bunkering of tugs undertaking towing operations is not permitted in South African waters whilst the tug is connected to the tow.
                                </li>
                                <li>
                                    It is necessary for another tug to connect to the tow whilst the towing tug is released to allow it to take bunkers.
                                </li>
                            </ul>
                            </li>

                            
                            
                            </ul>
                           
                </div>
               </div>
             </div>
             <p className="mb-4 font-18 font-600">
             Note: The current conditions / or restrictions are subject to further review based on ongoing risk assessments to be undertaken.</p>   
             <p className="mb-4">
             <a href={Doc1}>List of Agents for STS Bunkering</a>   
             </p>
             <p className="mb-4">
             <a href={Doc2}>List of Bunker Operators - Algoa bay</a>   
             </p>
             <p className="mb-4">
             <a href={Doc3}>List of Licenced operators  - Algoa Bay</a>   
             </p>
          </div>
    </div>
    
</div>
    </>
  );
}

export default OffshoreBunkering;